import { h } from '@stencil/core';
import { NOT_SPECIFIED_PROPERTY_VAL, RUNTIME_ERROR_CODES_TO_LABELS } from '../constants';
import { calculateMaxCapacity, validate } from '../utils';
export class PesMaxCapacityCell {
  constructor() {
    this.value = '';
    this.labels = undefined;
    this.runtimeParams = undefined;
    this.default = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  getValue() {
    var _a;
    if (!this.value || !((_a = this.runtimeParams) === null || _a === void 0 ? void 0 : _a.pwrRated)) {
      return 0;
    }
    return calculateMaxCapacity(this.value, this.runtimeParams.pwrRated);
  }
  getErrorMessage(errorCode) {
    var _a, _b;
    const labelCode = RUNTIME_ERROR_CODES_TO_LABELS.MAX_CAPACITY[errorCode];
    return (_b = (_a = this.labels) === null || _a === void 0 ? void 0 : _a[labelCode]) !== null && _b !== void 0 ? _b : null;
  }
  render() {
    if (this.default) {
      return h("div", null);
    }
    const errorMessage = this.getErrorMessage(validate(this.runtimeParams, this.value));
    const value = this.getValue();
    return (h("pes-runtime-base-cell", null, h("div", { slot: "value" }, errorMessage ? (NOT_SPECIFIED_PROPERTY_VAL) : (h("div", { class: "max-capacity-cell__indicator-container" }, h("pes-rainbow-bar", { class: "max-capacity-cell__indicator", min: 0, max: 100, value: value }), h("span", { class: "max-capacity-cell__measure-unit" }, `${value !== null && value !== void 0 ? value : 0} %`)))), errorMessage && h("div", { slot: "error" }, errorMessage)));
  }
  static get is() { return "pes-max-capacity-cell"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["pes-max-capacity-cell.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["pes-max-capacity-cell.css"]
    };
  }
  static get properties() {
    return {
      "value": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "runtime value"
        },
        "attribute": "value",
        "reflect": false,
        "defaultValue": "''"
      },
      "labels": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TRuntimeTranslations",
          "resolved": "{ enterTotalLoad: string; enteredLoadLessMinimum: string; hours: string; indicatesCapacity: string; maxCapacityUsed: string; minMax: string; minutes: string; pleaseEnterLoad: string; pleaseEnterLoadMaxCapacity: string; runTime: string; seconds: string; totalLoadExceeds: string; watts: string; }",
          "references": {
            "TRuntimeTranslations": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "runtime translations"
        }
      },
      "runtimeParams": {
        "type": "unknown",
        "mutable": false,
        "complexType": {
          "original": "TRuntimeAttributes",
          "resolved": "{ id?: string; vah: number; bcurveComp: number; bcurveExpo: number; bcurveSlope: number; bcurveScale: number; ptare: number; startPoint?: number; pwrRated: number; maxPower: number; }",
          "references": {
            "TRuntimeAttributes": {
              "location": "import",
              "path": "../types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "product runtime parameters"
        }
      },
      "default": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": "default props for run-time on comparison"
        },
        "attribute": "default",
        "reflect": false,
        "defaultValue": "false"
      }
    };
  }
  static get elementRef() { return "el"; }
}
